import React from 'react';

const MortgageRefinementAgeFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1372_9602)">
      <path d="M4.66667 15L3 13.3333L1.33333 15" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6.66667 18.6666H4.33333C3.97971 18.6666 3.64057 18.5262 3.39052 18.2761C3.14048 18.0261 3 17.6869 3 17.3333V13.3333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip1_1372_9602)">
      <path d="M15.3333 5L17 6.66667L18.6667 5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13.3333 1.33331H15.6667C16.0203 1.33331 16.3594 1.47379 16.6095 1.72384C16.8595 1.97389 17 2.31302 17 2.66665V6.66665"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip2_1372_9602)">
      <path
        d="M15 19.1666C17.3012 19.1666 19.1667 17.3012 19.1667 15C19.1667 12.6988 17.3012 10.8333 15 10.8333C12.6988 10.8333 10.8333 12.6988 10.8333 15C10.8333 17.3012 12.6988 19.1666 15 19.1666Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15 12.5V15L16.6667 15.8333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <g clipPath="url(#clip3_1372_9602)">
      <path
        d="M1.25 3.74998L5 0.833313L8.75 3.74998V8.33331C8.75 8.55433 8.6622 8.76629 8.50592 8.92257C8.34964 9.07885 8.13768 9.16665 7.91667 9.16665H2.08333C1.86232 9.16665 1.65036 9.07885 1.49408 8.92257C1.3378 8.76629 1.25 8.55433 1.25 8.33331V3.74998Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3.75 9.16667V5H6.25V9.16667" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1372_9602">
        <rect width="8" height="8" fill="white" transform="translate(0 12)" />
      </clipPath>
      <clipPath id="clip1_1372_9602">
        <rect width="8" height="8" fill="white" transform="translate(12)" />
      </clipPath>
      <clipPath id="clip2_1372_9602">
        <rect width="10" height="10" fill="white" transform="translate(10 10)" />
      </clipPath>
      <clipPath id="clip3_1372_9602">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MortgageRefinementAgeFilterIcon;
